import { cn } from "@c4c-web/libs-hooks/libs";
import { EAddressStatus } from "../../../constants/address.constants";
import { type IAddressListItemProps } from "./address-list.interface";
import { getAddressBadgeBorderColor } from "./address-list.helpers";

export const AddressListItem = ({
  children,
  selectedValue,
  status = "other",
  value,
  onSelect,
  closeDrawer,
}: IAddressListItemProps): JSX.Element => {
  const isSelected = selectedValue === value;
  const borderColor = getAddressBadgeBorderColor(isSelected, status);

  const handleClick = (): void => {
    if (status !== EAddressStatus.UNVERIFIED.toString()) {
      onSelect(value);
      closeDrawer?.(false);
    }
  };

  return (
    <label
      className={cn(
        "relative w-full border border-solid p-sm rounded-xl cursor-pointer bg-white",
        borderColor,
      )}
      htmlFor={value}
      onChange={handleClick as unknown as () => void}
    >
      {children}
    </label>
  );
};
